import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React from 'react';

function Information(props: SvgIconProps) {
  return (
    <SvgIcon width="20" height="21" viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10 .5c5.527 0 10 4.473 10 10s-4.473 10-10 10-10-4.473-10-10S4.473.5 10 .5zm0 1.563A8.433 8.433 0 0 0 1.562 10.5 8.433 8.433 0 0 0 10 18.938a8.433 8.433 0 0 0 8.438-8.438A8.433 8.433 0 0 0 10 2.062zm0 12.246a.977.977 0 1 1 0 1.953.977.977 0 0 1 0-1.953zm0-8.79a3.129 3.129 0 0 1 3.125 3.126 3.13 3.13 0 0 1-2.344 3.026v1.27a.781.781 0 1 1-1.562 0v-1.953c0-.431.35-.781.781-.781.862 0 1.563-.7 1.563-1.562 0-.862-.701-1.563-1.563-1.563s-1.563.701-1.563 1.563a.781.781 0 1 1-1.562 0A3.129 3.129 0 0 1 10 5.52z"
        fill="#DE7C30"
        fillRule="nonzero"
      />
    </SvgIcon>
  );
}

export default Information;
